export const dahliaShirts = ["rb365l", "rb366lt"];
